import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const reviewContainerStyle = css`
  display: flex;
  flex-direction: column;
`;

export const reviewSectionStyle = css`
  padding: ${theme.spacing(1)};
`;

export const reviewSectionHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing(2)};
  border-bottom: 1px solid ${theme.colors.neutral10};
  padding-bottom: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(2)};
`;

// Section titles can be long unbroken file names; let them wrap so the Edit action stays visible.
export const reviewSectionTitleStyle = css`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const reviewEditButtonStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  flex-shrink: 0;
  color: ${theme.colors.primary50};
  font-weight: ${theme.font.weight.bold};
`;

export const reviewFieldsGridStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(220px, 100%), 1fr));
  gap: ${theme.spacing(3)};
`;

export const reviewActionsStyle = css`
  display: flex;
  justify-content: flex-end;
`;
